import React from 'react'

import { At, Block, Sheet } from './_shared/positioned'

// Réplica do modelo "Fumigation Notice / Notificação de Fumigação" da Biofix (A4), com as coordenadas em pt
// do modelo. Cada linha do texto fixo é posicionada como no original; só os dados mudam.
const FONT = "'Times New Roman', Times, 'Liberation Serif', serif"
const LEFT = 20.8
const WIDTH = 543
const SIZE = 8.5

const Line = ({ y, italic, bold, size = SIZE, x = LEFT, children }) => (
  <At x={x} y={y} size={size} italic={italic} bold={bold}>
    {children}
  </At>
)

const Centered = ({ y, size = SIZE, bold, style, children }) => (
  <At x={LEFT} y={y} w={WIDTH} size={size} bold={bold} align="center" style={style}>
    {children}
  </At>
)

const Header = ({ data }) => (
  <>
    <img
      src="/pdfs/biofix/logo.png"
      alt="Biofix Agri"
      style={{ position: 'absolute', left: '192.4pt', top: '28.6pt', width: '199.5pt', height: '55.6pt' }}
    />
    <Centered y={95.7} size={11.4} bold>
      FUMIGATION NOTICE
    </Centered>
    <Centered y={113.6} size={10.4} bold>
      NOTIFICAÇÃO DE FUMIGAÇÃO
    </Centered>
    <Line y={130.1} bold size={9.5}>
      To
    </Line>
    <Line y={129.4} x={433.1} size={10.4}>
      O.S.
    </Line>
    <Line y={129.4} x={465.2} size={10.4}>
      {data.activityCode}
    </Line>
    <Line y={145.8} bold size={9.5}>
      Master
    </Line>
    <Line y={160} bold size={11.4}>
      {data.ship}
    </Line>
    <Line y={177.3} bold size={9.5}>
      In port
    </Line>
  </>
)

const Items = ({ data }) => (
  <>
    <Line y={205.8}>
      1. You are hereby notified that the cargo loaded on the vessel under your command will be fumigated as soon
      loading operations have been completed.
    </Line>
    <Line y={216.7} italic>
      Vimos por meio desta notificar que a mercadoria embarcada no navio sob seu comando será fumigada assim que a
      operação de embarque estiver
    </Line>
    <Line y={227.6} italic>
      completada.
    </Line>

    <Line y={258.9}>
      2. The fumigant to be used is Aluminium Phosphide. The product generates “phosphine” gas (PH3)
    </Line>
    <Line y={269.9} italic>
      O fumigante a ser usado é o Fosfeto de Alumínio. O produto gera o gás fosfina (PH3)
    </Line>

    <Line y={293.5}>
      3. Prior to fumigation ship´s personnel must without fail advise the techicans in charge the location of all
      manholes, ventilation and/or any opening to the
    </Line>
    <Line y={304.4}>holds and/or deck and/or other cargo compartments to be treated.</Line>
    <Line y={322.3} italic>
      Antes da fumigação a tripulação do navio deve sem falta avisar os técnicos quanto a posição de todos os
      agulheiros, ventiladores e/ou qualquer abertura
    </Line>
    <Line y={333.2} italic>
      para os porões e/ou cobertas e/ou outro compartimento a ser tratado.
    </Line>

    <Line y={356.9}>4. All holds are to be fully opened in order to fumigate.</Line>
    <Line y={367.8} italic>
      Todos os porões deverão estar completamente abertos para a fumigação.
    </Line>

    <Line y={391.4}>5. Prior to fumigation all manholes, ventilators, openings, etc are to be perfectly sealed.</Line>
    <Line y={402.4} italic>
      Antes da fumigação todos os agulheiros, ventiladores, aberturas, etc, deverão estar completamente fechados.
    </Line>

    <Line y={427.2}>6. In accordance with regulations in force the following informations is provided:</Line>
    <Line y={442.8} italic>
      As informações fornecidas, de acordo com os regulamentos vigentes:
    </Line>
    <Line y={457.2}>a) Spaces to be fumigated - holds / deck numbers,</Line>
    <Line y={454.8} x={251.8} italic>
      {data.holds}
    </Line>
    <Line y={469.2} italic>
      b)Os locais a serem fumigados - porões / cobertas números,
    </Line>
    <Line y={469.2} x={251.8} italic>
      {data.holds}
    </Line>
    <Line y={483.6}>
      c)The spaces not considered safe for ocupancy during application and fumigation are: holds / deck numbers:
    </Line>
    <Line y={483.6} x={495.9}>
      {data.holds}
    </Line>
    <Line y={498} x={34.1} italic>
      d)Os locais não considerados seguros para a ocupação durante aplicação e fumigação são porões / cobertas números:
    </Line>
    <Line y={498} x={511.3} italic>
      {data.holds}
    </Line>

    <Line y={529.2}>
      7. The characteres of the fumigant fumes are: colouress, odour or decaying fish, garlic or commercial carbide,
      slightly heavier than air.
    </Line>
    <Line y={543.6} italic>
      As características do gás fumigante são: incolor, odor de peixe em decomposição, alho ou carbureto, levemente mais
      pesado que o ar.
    </Line>
    <Line y={561.4}>
      That I accept the requerimets that shipholds, manholes, ventilators, etc. must be completely sealed during{' '}
      {data.days} days to obtain the best resultants of fumigation.
    </Line>
    <Line y={590.2} italic>
      Portanto eu aceito os requerimentos de que os porões, agulheiros, ventiladores, etc. devem estar completamente
      vedados por {data.days} dias para obter os melhores
    </Line>
    <Line y={601.1} italic>
      resultados de fumigação.
    </Line>
    <Line y={625.1} bold size={9.5}>
      After {data.days} days of exposure goods should be ventilated. The holds should be opened on the sea in order to
      allow the aeration.
    </Line>
  </>
)

const Footer = ({ data }) => (
  <>
    <Line y={656.5} bold>
      Date:
    </Line>
    <At x={96.9} y={656.1} w={110.4} bold align="center">
      {data.dateEn}
    </At>
    <Line y={673.1} bold>
      Data:
    </Line>
    <At x={96.9} y={672.6} w={110.4} bold align="center">
      {data.datePt}
    </At>
    <Centered y={703.4}>
      MASTER <i>(COMANDANTE)</i>
    </Centered>
    <Centered y={718.5}>KINDLY ACKNOWLEDGE RECEIPT BY SIGNING THE ATTACHED COPY</Centered>
    <Centered y={733.5}>GENTILEZA RECONHECER O RECEBIMENTO DESTA ASSINANDO AS CÓPIAS</Centered>
    <Centered y={775.3} size={6.6} style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
      HEAD OFFICE: Rua Piauí, n° 1299 - sala 4-A, Centro - Avaré/SP - CEP 11020-003 - Fone/Fax: +55 (13) 3877-8322
    </Centered>
    <Centered y={783.9} size={6.6} style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
      EMAIL: brazil@biofixagri.com
    </Centered>
  </>
)

const NoticeDocument = ({ data }) => (
  <div id="pdfPage" style={{ width: '595.2pt', background: '#fff', fontFamily: FONT, color: '#000' }}>
    <style>{`@page { size: A4; margin: 0 }`}</style>
    <Sheet left={0}>
      <Block top={0} height={800} plain>
        <Header data={data} />
        <Items data={data} />
        <Footer data={data} />
      </Block>
    </Sheet>
  </div>
)

export default NoticeDocument
